import React, { useState } from 'react';
import { Stats } from './components/Stats/Stats';
import { ActionsBar } from './components/ActionsBar/ActionsBar';
import { FlowChart } from './components/FlowChart/FlowChart';
import { UserType } from './EstatePlanningFlow.meta';
import { FlowTable } from './components/FlowTable/FlowTable';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import { useDocumentTitle } from '../../../../../../_hooks/useDocumentTitle';

export const EstatePlanningFlow = () => {
  useDocumentTitle('Goals - Estate Planning Estate Flow');

  const [userType, setUserType] = useState<UserType>(UserType.Principal);
  const [isFlowVisible, setIsFlowVisible] = useState(true);

  return (
    <Box mt="24">
      <ActionsBar
        userType={userType}
        setUserType={setUserType}
        onToggleView={() => setIsFlowVisible(state => !state)}
        isFlowChartSelected={isFlowVisible}
      />

      <Stats userType={userType} />

      {isFlowVisible ? <FlowChart userType={userType} /> : <FlowTable userType={userType} />}
    </Box>
  );
};
